var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('v-img',_vm._b({attrs:{"contain":"","src":_vm.imgAthleteSoccerBackgroundLeft}},'v-img',_vm.$attrs,false),[_vm._t("default")],2),_c('v-spacer'),_c('v-img',_vm._b({attrs:{"contain":"","src":_vm.imgAthleteSoccerBackgroundRight}},'v-img',_vm.$attrs,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }